module.exports = __webpack_public_path__ + "banner-IntheSpotlight_PR.jpg";